import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Recruiter } from '@app/model/recruiter';
import { environment } from '@environments/environment';
import { JobRecruiterMappingSerializer } from '@app/model/serializer/job-recruiter-mapping-serializer';


@Injectable({ providedIn: 'root' })
export class JobRecruiterMappingService extends ApiService<Recruiter> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job-recruiter-mapping',
      new JobRecruiterMappingSerializer());
  }
}
